import {UIMSingletonPageController} from '../ui_fullscreen/UIMSingletonPageController.ts'
import {UIMAdController} from '../ui_ad/UIMAdController.ts'
import {UIMMainPageController} from './main_page/UIMMainPageController.ts'
import {UIMSceneController} from './UIMSceneController.ts'
import {UIMCreateRoomController} from './room/UIMCreateRoomController.ts'
import {stripOAuthTokenFromUrl} from '../../../shared/scripts/ui_utils/TestableClientUtils.ts'
import {UIMLoginController} from '../UIMLoginController.ts'
import {UIMDeviceHandler} from './UIMDeviceHandler.ts'
import {UIVLIController} from '../../../shared/scripts/ui_ad/UIVLIController.ts'
import {UIMManagerEvents} from './UIMManagerEvents.ts'
import {UIMGameOrientationController} from '../UIMGameModeController.ts'
import {PushNotificationPopupIntentEnum, UIMRequestPushNotificationController} from '../notifications/UIMRequestPushNotificationController.ts'
import {UIUtilsFriends} from '../../../shared/scripts/ui_friends/UIUtilsFriends.ts'
import {UIMSceneEnum} from '../../../../shared/enums/UIMSceneEnums.ts'
import {type MatchType} from '@colonist/game-base-types'

export class UIMManager {
    readonly uiManagerEvents: UIMManagerEvents
    readonly singletonPageController: UIMSingletonPageController
    readonly adController: UIMAdController
    readonly sceneController: UIMSceneController
    readonly mainpageController: UIMMainPageController
    readonly createRoomController: UIMCreateRoomController
    readonly vliController: UIVLIController
    readonly loginController: UIMLoginController

    constructor() {
        new UIMGameOrientationController()
        this.uiManagerEvents = new UIMManagerEvents(this)
        this.sceneController = new UIMSceneController(this)
        this.createRoomController = new UIMCreateRoomController()
        this.mainpageController = new UIMMainPageController(this.sceneController)
        this.singletonPageController = new UIMSingletonPageController(this.mainpageController)
        this.adController = new UIMAdController(this)
        this.vliController = new UIVLIController()
        this.loginController = new UIMLoginController()

        stripOAuthTokenFromUrl()

        void ((window as any).deviceHandler = UIMDeviceHandler)
        this.initializePushNotificationPopup()
    }

    init() {
        this.singletonPageController.handleUrlRedirect(window.location.href)
        this.createRoomController.init()
    }

    // eslint-disable-next-line class-methods-use-this
    private initializePushNotificationPopup() {
        UIUtilsFriends.callbackActionOnFriendRequestSent.push(() => {
            UIMRequestPushNotificationController.showRequestPushNotification(PushNotificationPopupIntentEnum.OnUserSentFriendRequest)
        })
    }

    async goToMainPageAndSelectMatchType(matchType: MatchType) {
        await this.mainpageController.bodyController.modeSelectorController.waitUntilInitialized
        this.sceneController.loadScene(UIMSceneEnum.Homepage)
        this.mainpageController.bodyController.modeSelectorController.selectCardByMatchType(matchType)
    }
}
